"use strict";
exports.__esModule = true;
function getTranslate(placement) {
    var pos = placement.split("-");
    var relevantPlacement = pos[1] === "center" ? pos[0] : pos[1];
    var translateMap = {
        bottom: "translate3d(0, 120%, 0)",
        left: "translate3d(-120%, 0, 0)",
        right: "translate3d(120%, 0, 0)",
        top: "translate3d(0, -120%, 0)"
    };
    return translateMap[relevantPlacement];
}
var toastStates = function (placement) { return ({
    entered: { transform: "translate3d(0,0,0)" },
    entering: { transform: getTranslate(placement) },
    exited: { transform: "scale(0.66)", opacity: 0 },
    exiting: { transform: "scale(0.66)", opacity: 0 }
}); };
exports["default"] = toastStates;
